import { useCallback, useEffect, useState } from 'react';
import { getPendingOfficers, approveOfficer, rejectOfficer } from '../services/officersService';

export function usePendingOfficers(enabled = true) {
  const [officers, setOfficers] = useState([]);
  const [loading, setLoading] = useState(enabled);

  const refetch = useCallback(() => {
    if (!enabled) return Promise.resolve();
    setLoading(true);
    return getPendingOfficers()
      .then(setOfficers)
      .catch(() => setOfficers([]))
      .finally(() => setLoading(false));
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setOfficers([]);
      setLoading(false);
      return;
    }

    let mounted = true;
    refetch().then(() => {
      if (!mounted) return;
    });
    return () => {
      mounted = false;
    };
  }, [enabled, refetch]);

  const approve = useCallback(
    async (authId, label) => {
      await approveOfficer(authId, label);
      await refetch();
    },
    [refetch]
  );

  const reject = useCallback(
    async (authId, label) => {
      await rejectOfficer(authId, label);
      await refetch();
    },
    [refetch]
  );

  return { officers, loading, approve, reject };
}
